import { useDispatch, useSelector } from 'react-redux';
import { ReusableDataTable } from '@operations/shared';
import { viewAdvanceInstallments, stepperMoving, setMaxAdvanceDiscount } from '../../../stores/actions';


export default function ViewAdvances() {
    const userActiveAdvances = useSelector((state: any) => state.actionsReducer?.info);
    const stepNumber = useSelector((state: any) => state.actionsReducer?.stepNumber);

    const dispatch = useDispatch();
    const getAdvanceInstallment = (advanceID: string) => {
        const advance = userActiveAdvances?.advances?.find((advance: any) => advance?.advanceID === advanceID);
        dispatch(viewAdvanceInstallments(advance?.installments));
        dispatch(setMaxAdvanceDiscount({ maxAdvanceDiscount: advance?.maxAllowedDiscountAmount, advanceID: advanceID }));
        dispatch(stepperMoving(stepNumber + 1));
    }
    const assignAdvanceId: any = {
        title: 'Advance ID',
        dataIndex: 'advanceID',
        render: (advanceID: string, record: { maxAllowedDiscountAmount: number }) => (
            <div>
                <span
                    style={record?.maxAllowedDiscountAmount === 0 ? {} : { textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => { record?.maxAllowedDiscountAmount !== 0 && getAdvanceInstallment(advanceID) }}
                > {advanceID}</span>

            </div>
        ),
    };
    let columns = [
        {
            title: 'Max Allowed Discount Amount',
            dataIndex: 'maxAllowedDiscountAmount',
            key: 'maxAllowedDiscountAmount',
        }
    ];
    columns = [assignAdvanceId, ...columns];
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }}>
                <ReusableDataTable columns={columns} hiddenRefreshing
                    apiLink={``} rows={userActiveAdvances?.advances}
                    pagination={false} loading={false} scrolling={{ x: 100, y: 300 }} />
            </div>
        </>
    )
}
